import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../UserContext";

import CenteredPageContainer from "../components/layout_components/CenteredPageContainer";
import CardLayout from "../components/layout_components/CardLayout";
import { TextInput, SelectInput } from "../components/common_components/Forms";
import Button from "../components/common_components/Button";

import TimezoneList from "../../../user_portal/preauth_portal/components/TimezoneList";

// API Calls
import AccountAPI from "../api/api_calls/AccountAPI";



function AccountSettings(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();

    // Form data
    const [formData, setFormData] = useState({
        email: user.email,
        password: "",
        password_confirmation: "",
    });
    const [errors, setErrors] = useState({});

    // Reset token
    const [resetToken, setResetToken] = useState("");
    useEffect(() => {
        const generateResetToken = async () => {
            const data = await AccountAPI.generateResetToken();
            setResetToken(data.data.reset_password_token);
        }
        generateResetToken();
        document.title = 'Account Settings | Despark';
    }, []);

    // Handle submit
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevents page reload
        setErrors({}); // Clear previous errors

        // Check if passwords match
        if (formData.password !== formData.password_confirmation) {
            setErrors({ password_confirmation: "Passwords do not match" });
            return;
        }

        // Check if password is at least 8 characters long
        if (formData.password.length < 8) {
            setErrors({ password: "Password must be at least 8 characters long" });
            return;
        }

        // Update password
        try {
            const data = await AccountAPI.update({ password: formData.password, password_confirmation: formData.password_confirmation, reset_password_token: resetToken });

            if (data.success) {
                alert.show("Password updated", { type: 'success' });
                refreshUser();
            } else {
                if (data.error) {
                    alert.show(data.error, { type: 'error' });
                } else {
                    alert.show("Unable to update password", { type: 'error' });
                }
            }
        } catch (error) {
            console.error("Error updating password:", error);
            alert.show("An unexpected error occurred.", { type: 'error' });
        }
    };

    // Handle form change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };



    return (
        <CenteredPageContainer>
            <CardLayout>
                <div className="profile-header-container">
                    <h1>Account Settings</h1>

                </div>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <TextInput
                        label="Email"
                        name="email"
                        placeholder="Email"
                        value={user.email}
                        disabled={true}
                        readOnly={true}
                        type="email"
                        error={errors.email}
                    />
                    <TextInput
                        label="New password"
                        name="password"
                        value={formData.password}
                        placeholder="**********"
                        onChange={handleChange}
                        error={errors.password}
                        type="password"
                    />
                    <TextInput
                        label="Confirm new password"
                        name="password_confirmation"
                        value={formData.password_confirmation}
                        placeholder="**********"
                        onChange={handleChange}
                        error={errors.password_confirmation}
                        type="password"
                    />

                    <Button type="submit">Submit</Button>
                </form>
            </CardLayout>
        </CenteredPageContainer>
    )
}


export default AccountSettings